import { useState, useEffect } from 'react'

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 40,
  })

  useEffect(() => {
    // Check if we have a saved end time in localStorage
    const savedEndTime = localStorage.getItem('arsenal_countdown_end')
    let endTime: number

    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10)
      // If the saved time is in the past, reset it to 24h from now
      if (endTime < Date.now()) {
        endTime = Date.now() + 24 * 60 * 60 * 1000
        localStorage.setItem('arsenal_countdown_end', endTime.toString())
      }
    } else {
      // Set new end time to 24h from now
      endTime = Date.now() + 24 * 60 * 60 * 1000
      localStorage.setItem('arsenal_countdown_end', endTime.toString())
    }

    const interval = setInterval(() => {
      const now = Date.now()
      const difference = endTime - now

      if (difference <= 0) {
        clearInterval(interval)
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 })
      } else {
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        )
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60),
        )
        const seconds = Math.floor((difference % (1000 * 60)) / 1000)

        setTimeLeft({ hours, minutes, seconds })
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return timeLeft
}
